export const parseGaProducts = (gaProducts: string) => {
  try {
    return JSON.parse(gaProducts);
  } catch (_) {
    return;
  }
};
